import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LinksProvider } from "./lib/LinksContext";
import { ContentProvider } from "./lib/ContentContext";
import RouteMeta from "./lib/RouteMeta";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import AnnouncementPopup from "./components/AnnouncementPopup";
import Home from "./pages/Home";
import Eugenie from "./pages/Eugenie";
import Clinique from "./pages/Clinique";
import Conversations from "./pages/Conversations";
import Article from "./pages/Article";
import Medias from "./pages/Medias";
import Conferences from "./pages/Conferences";
import Projets from "./pages/Projets";
import Contact from "./pages/Contact";
import Confidentialite from "./pages/Confidentialite";
import Ressources from "./pages/Ressources";
import Admin from "./pages/Admin";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <LinksProvider>
        <ContentProvider>
          <RouteMeta />
          <ScrollManager />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/eugenie" element={<Eugenie />} />
          <Route path="/clinique" element={<Clinique />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/conversations/:slug" element={<Article />} />
          <Route path="/medias" element={<Medias />} />
          <Route path="/conferences" element={<Conferences />} />
          <Route path="/projets" element={<Projets />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/ressources" element={<Ressources />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
        <AnnouncementPopup />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#24382F",
              color: "#FAF8F2",
              border: "1px solid #CD7D44",
              borderRadius: "9999px",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        </ContentProvider>
      </LinksProvider>
    </BrowserRouter>
  );
}
